<script setup lang="ts">
import { getStringQuery } from 'theme/utils/getQuery';
import RegisterUserByLineForQuestionnaireTemplate from '~/components/templates/RegisterUserTemplate/RegisterUserByLineForQuestionnaireTemplate.vue';
import RegisterUserByLineTemplate from '~/components/templates/RegisterUserTemplate/RegisterUserByLineTemplate.vue';

const route = useRoute();
const isForQuestionnaire = computed((): boolean => {
  // TODO: 実際のリダイレクト処理がtemplateの子にあり、
  // 処理が分散しているためeventを使うなりしてpage側に集約する
  const redirectTo = getStringQuery(route.query.redirect);
  return redirectTo?.includes('/questionnaire/') ?? false;
});

const redirectLocation = computed(
  () => getStringQuery(route.query.redirect) ?? '/my/overview'
);
const router = useRouter();
onBeforeMount(async () => {
  const { isAuthenticated } = await useAuthenticationState();
  if (!isAuthenticated.value) return;
  router.replace(redirectLocation.value);
});

useAppMeta({ title: '会員登録' });
definePageMeta({ layout: 'register' });
</script>

<template>
  <ClientOnly>
    <RegisterUserByLineForQuestionnaireTemplate v-if="isForQuestionnaire" />
    <RegisterUserByLineTemplate v-else />
  </ClientOnly>
</template>
